import { OrganizationUser } from '@enview/interface/types/OrganizationUser';
import { track } from './AmplitudeAnalytics';

enum AnalyticsEvent {
  USER_SIGNED_IN = 'Signed In',
  USER_SIGN_IN_FAILED = 'Sign-in failed',
  USER_SIGNED_OUT = 'Signed Out',
}

export const trackSignIn = (orgUser: OrganizationUser): void => {
  track(AnalyticsEvent.USER_SIGNED_IN, {
    username: orgUser.email,
  });
};

export const trackSignInFailed = (): void => {
  track(AnalyticsEvent.USER_SIGN_IN_FAILED, {});
};

export const trackSignOut = (orgUser?: OrganizationUser): void => {
  track(AnalyticsEvent.USER_SIGNED_OUT, {
    username: orgUser?.email,
  });
};
